import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, Form, Input, Progress, Select, message, Row, Col } from "antd";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import AppBar from "@mui/material/AppBar";
import List from "@mui/material/List";
import Grid from "@mui/material/Grid";
import { InfoCircleOutlined } from "@ant-design/icons";

const countriesApi = process.env.REACT_APP_API_Countries;
const mobileoOperatorsApi = process.env.REACT_APP_API_MobileOperators;
const simCardsApi = process.env.REACT_APP_API_SIMCards;
const twoColors = {
  "0%": "#108ee9",
  "100%": "#87d068",
};
const AddSimCard = ({ setOpen }) => {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoadingFacebook] = useState(false);
  const [progress, setProgress] = useState(0);
  const [country, setCountry] = useState("");
  const [mnoName, setMNOName] = useState("");
  const [mnoNameList, setMNONameList] = useState();
  const [dialingCode, setDialingCode] = useState("");
  const [msisdn, setMSISDN] = useState("");
  const [countryList, setCountryList] = useState();
  const [countryObject, setCountryObject] = useState();
  useEffect(() => {
    const dataUrl = countriesApi;
    fetch(dataUrl)
      .then((res) => res.json())
      .then((res) => {
        setCountryList(res.body);
      });
  }, []);
  const AddSimCard = async () => {
    if (
      country === "" ||
      mnoName === "" ||
      dialingCode === "" ||
      msisdn === ""
    ) {
      messageApi.error("Kindly Fill All Fields");
    } else {
      const progressInterval = setInterval(() => {
        setProgress((prevProgress) =>
          prevProgress < 90 ? prevProgress + 5 : 90
        );
      }, 300);
      setLoadingFacebook(true);
      messageApi.open({
        type: "loading",
        content: "Action in progress..",
        duration: 5,
      });

      const createitems = simCardsApi;
      const data = {
        mno_id: mnoName,
        msisdn: msisdn,
      };
      axios
        .post(createitems, data)
        .then((response) => {
          if (response.status) {
            messageApi.success("Number Registered Successfully");
            setOpen(false);
          } else {
            messageApi.error("Number Not Registered");
          }
        })
        .catch((error) => {
          messageApi.error("An Error Occurred");
        })
        .finally(() => {
          clearInterval(progressInterval);
          setLoadingFacebook(false);
        });
    }
  };

  const { Option } = Select;

  return (
    <>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => setOpen(false)}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Add Sim Card
          </Typography>
        </Toolbar>
      </AppBar>
      <List style={{ height: "60vh" }}>
        <Grid
          container
          style={{ height: "50%", justifyContent: "center" }}
          alignItems="center"
        >
          <Grid item xs={12} sm={8} md={6} lg={8}>
            <Form
              form={form}
              layout="vertical"
              className="ml-10 mr-10 pl-10 pt-10 pr-10 pb-4 bg-[#FFFFFF]"
            >
              <div className=" mb-4">
                <h2 className="text-2xl font-bold">Add Sim Card</h2>
              </div>
              <div className="grid grid-cols-1 gap-4">
                {contextHolder}
                <Row gutter={16}>
                  <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                    <Form.Item
                      label="Country"
                      required
                      tooltip={{
                        title: "This is a required field",
                        icon: <InfoCircleOutlined />,
                      }}
                    >
                      <Select
                        showSearch
                        placeholder="Select your country"
                        value={country}
                        onChange={(value) => {
                          const dataUrl = `${countriesApi}/${value}`;
                          fetch(dataUrl)
                            .then((res) => res.json())
                            .then((res) => {
                              setCountryObject(res.body);
                              setCountry(res.body.name);
                              setDialingCode(res.body.dialing_code);
                              const dataUrl = `${mobileoOperatorsApi}?country=${value}`;
                              fetch(dataUrl)
                                .then((res) => res.json())
                                .then((res) => {
                                  setMNONameList(res.body);
                                });
                            });
                          setMNOName("");
                        }}
                        style={{ width: "100%" }}
                      >
                        {countryList?.map((country) => (
                          <Option key={country?.id} value={country?.id}>
                            {country?.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                    <Form.Item
                      label="MNO Name"
                      required
                      tooltip={{
                        title: "This is a required field",
                        icon: <InfoCircleOutlined />,
                      }}
                    >
                      <Select
                        showSearch
                        placeholder="Select your MNO Name"
                        value={mnoName}
                        onChange={(value) => setMNOName(value)}
                        style={{ width: "100%" }}
                        disabled={!country}
                      >
                        {mnoNameList?.map((mno) => (
                          <Option key={mno.id} value={mno.id}>
                            {mno.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                    <Form.Item
                      label="Dialing Code"
                      required
                      tooltip={{
                        title: "This is a required field",
                        icon: <InfoCircleOutlined />,
                      }}
                    >
                      <Select
                        showSearch
                        placeholder="Select your Dialing Code"
                        value={dialingCode}
                        onChange={(value) => setDialingCode(value)}
                        style={{ width: "100%" }}
                        disabled={!country}
                      >
                        <Option
                          key={countryObject?.id}
                          value={countryObject?.dialing_code}
                        >
                          {countryObject?.dialing_code}
                        </Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                    <Form.Item
                      label="MSISDN"
                      required
                      tooltip={{
                        title: "This is a required field",
                        icon: <InfoCircleOutlined />,
                      }}
                    >
                      <Input
                        type="text"
                        placeholder="Enter your MSISDN"
                        value={msisdn}
                        onChange={(event) => {
                          setMSISDN(event.target.value);
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item>
                  <div className="flex justify-end">
                    <Button
                      onClick={() => {
                        AddSimCard();
                      }}
                      className="btn btn-xs sm:btn-sm md:btn-md lg:btn-md bg-primaryColor text-[white] ml-2"
                    >
                      Add SIM Card
                    </Button>
                  </div>
                </Form.Item>
                {loading && (
                  <div>
                    <Progress percent={progress} strokeColor={twoColors} />
                  </div>
                )}
              </div>
            </Form>

            {/* </form> */}
          </Grid>
        </Grid>
      </List>
    </>
  );
};

export default AddSimCard;
